import React, {Component} from "react";
import Dialog from '@mui/material/Dialog';
import {
    DialogActions,
    DialogTitle,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Switch
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import {connect} from "react-redux";
import {
    close_test_dialog,
    open_test_dialog,
    set_case_sensitivity,
    set_character_boxes_visibility,
    set_col_names,
    set_from_last_answers,
    set_randomize_row_order,
    set_source_col,
    set_target_col,
    set_target_col2,
    set_test_type,
    set_time_for_answer,
    start_test
} from "../../actions/test";
import withStyles from "@mui/styles/withStyles";
import {withRouter} from "react-router-dom";
import TextField from "@mui/material/TextField";
import Validator from "../../utilities/validator";
import {ToggleButton, ToggleButtonGroup} from "@mui/lab";

const styles = {
    formControl: {
        width: "100%",
        display: "block",
        marginBottom: 15
    },
    dialog: {
        minWidth: "270px",
        // display: "block",
        // marginBottom: 15
    },
}

class TestConfigDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            timeForAnswer: null
        };
    }

    getColList() {
        let columns = {};
        if (this.props.cluster_id) {
            const cluster = this.props.clusters.find(cluster => cluster.id === parseInt(this.props.cluster_id));
            columns[1] = cluster.col_1_name;
            if (cluster.col_2_name) columns[2] = cluster.col_2_name;
            //columns[2] = cluster.col_2_name;
            if (cluster.col_3_name) columns[3] = cluster.col_3_name;
        }
        return columns;
    }

    isInvalid() {
        return this.props.source_col === 0 || this.props.target_col === 0 //|| Validator.isTimeValid(this.props.time_for_answer)
    }

    startTest() {
        this.props.set_col_names(this.getColList());
        this.props.start_test();
        this.props.history.push('/clusters/' + this.props.cluster_id + '/test');
    }

    handleTimeForAnswerChanged(e) {
        this.setState({
            ...this.state,
            timeForAnswer: e.target.value
        });

        this.props.set_time_for_answer(e.target.value);
    }


    render() {
        const {classes} = this.props;
        return (<Dialog open={this.props.dialog_open} onClose={this.props.close_test_dialog}
                        aria-labelledby="form-dialog-title">
                <DialogTitle>LEARNING & PRACTICE</DialogTitle>
                <DialogContent className={classes.dialog}>
                    <ToggleButtonGroup
                        color="primary"
                        value={this.props.test_type}
                        fullWidth
                        exclusive
                        onChange={(e, value) => value != null && this.props.set_test_type(value)}
                        aria-label="Input type" style={{marginBottom: 15}}
                    >
                        <ToggleButton value="text">Text input</ToggleButton>
                        <ToggleButton value="choice">Choices</ToggleButton>
                    </ToggleButtonGroup>

                    <FormControl className={classes.formControl} variant="standard">
                        <InputLabel id="source-label">Question column</InputLabel>
                        <Select
                            labelId="source-label"
                            fullWidth
                            value={this.props.source_col}
                            onChange={(e) => this.props.set_source_col(e.target.value)}
                        >
                            <MenuItem value={0} key={0}><em>None</em></MenuItem>

                            {this.props.dialog_open && Object.entries(this.getColList()).map((item) =>
                                this.props.target_col !== parseInt(item[0]) &&
                                this.props.target_col2 !== parseInt(item[0]) &&
                                <MenuItem value={item[0]} key={item[0]}>{item[1]}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl} variant="standard">
                        <InputLabel id="target-label">Answer column</InputLabel>
                        <Select
                            labelId="target-label"
                            fullWidth
                            value={this.props.target_col}
                            onChange={(e) => this.props.set_target_col(e.target.value)}
                        >
                            <MenuItem value={0} key={0}><em>None</em></MenuItem>
                            {this.props.dialog_open && Object.entries(this.getColList()).map((item) =>
                                this.props.source_col !== parseInt(item[0]) &&
                                this.props.target_col2 !== parseInt(item[0]) &&
                                <MenuItem value={item[0]} key={item[0]}>{item[1]}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    {this.props.test_type === "text" && <FormControl className={classes.formControl} variant="standard">
                        <InputLabel id="target-label2">Second answer column</InputLabel>
                        <Select
                            labelId="target-label2"
                            fullWidth
                            value={this.props.target_col2}
                            onChange={(e) => this.props.set_target_col2(e.target.value)}
                        >
                            <MenuItem value={0} key={0}><em>None</em></MenuItem>
                            {this.props.dialog_open && Object.entries(this.getColList()).map((item) =>
                                this.props.source_col !== parseInt(item[0]) &&
                                this.props.target_col !== parseInt(item[0]) &&
                                <MenuItem value={item[0]} key={item[0]}>{item[1]}</MenuItem>
                            )}
                        </Select>
                    </FormControl>}

                    {this.props.test_type === "text" && <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={<Switch
                                color="primary"
                                checked={this.props.visible_character_boxes}
                                onChange={(e) => this.props.set_character_boxes_visibility(Boolean(e.target.checked))}
                                name="visible-character-boxes"
                            />}
                            label="Number of letters recognition"
                        />
                    </FormControl>}
                    {this.props.test_type === "text" && <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={<Switch
                                color="primary"
                                checked={this.props.randomize_row_order}
                                onChange={(e) => this.props.set_randomize_row_order(Boolean(e.target.checked))}
                                name="randomize-row-order"
                            />}
                            label="Random content selection"
                        />
                    </FormControl>}
                    {this.props.test_type === "text" && <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={<Switch
                                color="primary"
                                checked={this.props.case_sensitivity}
                                onChange={(e) => this.props.set_case_sensitivity(Boolean(e.target.checked))}
                                name="case-sensitivity"
                            />}
                            label="Capital letters recognition"
                        />
                    </FormControl>}
                    <FormControl className={classes.formControl}>
                        <TextField fullWidth label="Time-limit counter (in seconds)" variant="outlined" required
                                   value={this.props.time_for_answer} type="number"
                                   onChange={this.handleTimeForAnswerChanged.bind(this)}
                                   error={!Validator.isTimeValid(this.state.timeForAnswer)}
                                   helperText={!Validator.isTimeValid(this.state.timeForAnswer) ? "Please enter valid number value. Maximal allowed value is 250" : ""}
                        />

                    </FormControl>

                    {this.props.cluster_id in this.props.last_wrong_answers && this.props.last_wrong_answers[this.props.cluster_id].length > 0 &&
                    <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={<Switch
                                color="primary"
                                checked={this.props.from_last_answers}
                                onChange={(e) => this.props.set_from_last_answers(Boolean(e.target.checked))}
                                name="case-sensitivity"
                            />}
                            label={"Memorizing last mistakes only (" + this.props.last_wrong_answers[this.props.cluster_id].length + ")"}
                        />
                    </FormControl>}


                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.close_test_dialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.startTest.bind(this)} disabled={this.isInvalid()} color="primary">
                        Start
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = state => ({
    visible_character_boxes: state.test.visible_character_boxes,
    randomize_row_order: state.test.randomize_row_order,
    case_sensitivity: state.test.case_sensitivity,
    test_type: state.test.test_type,
    dialog_open: state.test.dialog_open,
    cluster_id: state.test.cluster_id,
    source_col: state.test.source_col,
    target_col: state.test.target_col,
    target_col2: state.test.target_col2,
    from_last_answers: state.test.from_last_answers,
    time_for_answer: state.test.time_for_answer,
    clusters: state.clusters.clusters,
    last_wrong_answers: state.test.last_wrong_answers
});
export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {
        start_test, set_character_boxes_visibility, set_randomize_row_order, set_case_sensitivity, set_test_type,
        set_source_col, set_target_col, set_target_col2, set_time_for_answer, open_test_dialog,
        close_test_dialog, set_col_names, set_from_last_answers
    }
)(TestConfigDialog)));
